





























import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive } from 'vue-property-decorator'
import { ContentItemCollectionTypeInAdmin } from '@/modules/content-item/models/content-item-collection.model'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentItemActions from '@/modules/content-item/components/admin/table/AdminContentItemActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'
import ContentItemStatusView from '@/modules/content-item/components/shared/ContentItemStatusView.vue'
import ContentItemDeliverAt from '@/modules/content-item/components/shared/ContentItemDeliverAt.vue'
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';

@Component({
  components: {
    TesTr,
    TesTd,
    TextEllipsis,
    QTooltip
  }
})
export default class AdminContentItemRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(private readonly routes: AdminContentItemRoutes) {
    super()
  }

  @InjectReactive()
  contentItems!: ContentItemCollectionTypeInAdmin

  get withData() {
    return {
      statuses: this.contentItems.statuses
    }
  }

  columnComponents = {
    editor: {
      component: AdminUserInfoButton,
      handler: value => ({ basicUser: value, asText: true })
    },
    status: {
      component: ContentItemStatusView,
      handler: (value, row, withData) => ({ status: value, statuses: withData.statuses })
    },
    deliver_at: {
      component: ContentItemDeliverAt,
      handler: value => ({ isoDate: value, defaultText: '' })
    },
    register_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value, defaultText: '' })
    },
    writer: {
      component: AdminUserInfoButton,
      handler: value => ({ basicUser: value, asText: true })
    },
    actions: {
      component: AdminContentItemActions,
      handler: (value, row) => ({
        contentItemId: row.id,
        contentItemShowPageRoute: this.itemShowPageRoute(row.id)
      })
    }
  }

  itemShowPageRoute(id) {
    return this.routes.show(id)
  }
}
